import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { motion } from "framer-motion";
import { CircuitryIcon, EnvelopeSimpleIcon, LockKeyIcon, ArrowRightIcon } from "@phosphor-icons/react";

const BG = "https://images.unsplash.com/photo-1742477012583-804ba592b2c8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwdGVjaCUyMHJlcGFpciUyMG1vdGhlcmJvYXJkfGVufDB8fHx8MTc3ODExODEwM3ww&ixlib=rb-4.1.0&q=85";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("admin@assistencia.com");
  const [password, setPassword] = useState("admin123");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) nav("/", { replace: true });
    else setError(res.error || "Falha no login");
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center px-4">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${BG})` }}
      />
      <div className="absolute inset-0 bg-black/70 backdrop-blur-[2px]" />
      <div
        className="absolute inset-0 opacity-50"
        style={{
          background:
            "radial-gradient(ellipse at top right, rgba(37,99,235,0.25), transparent 50%), radial-gradient(ellipse at bottom left, rgba(16,185,129,0.18), transparent 50%)",
        }}
      />

      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="relative z-10 w-full max-w-md"
      >
        <div className="glass-strong rounded-2xl p-8 shadow-2xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-blue-500 to-emerald-500 flex items-center justify-center shadow-[0_0_30px_rgba(59,130,246,0.5)]">
              <CircuitryIcon size={26} weight="duotone" className="text-white" />
            </div>
            <div>
              <h1 className="font-display text-2xl font-bold text-white">Assistência Manager</h1>
              <p className="text-xs uppercase tracking-[0.2em] text-blue-400/80">
                ERP para assistência técnica
              </p>
            </div>
          </div>

          <form onSubmit={onSubmit} className="space-y-5" data-testid="login-form">
            <div>
              <label className="block text-xs uppercase tracking-wider text-slate-400 mb-2">
                E-mail
              </label>
              <div className="relative">
                <EnvelopeSimpleIcon
                  size={18}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500"
                />
                <input
                  type="email"
                  required
                  data-testid="login-email-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full bg-black/30 border border-white/10 backdrop-blur rounded-lg pl-10 pr-4 py-3 text-white placeholder:text-slate-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none transition"
                  placeholder="seu@email.com"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs uppercase tracking-wider text-slate-400 mb-2">
                Senha
              </label>
              <div className="relative">
                <LockKeyIcon
                  size={18}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500"
                />
                <input
                  type="password"
                  required
                  data-testid="login-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full bg-black/30 border border-white/10 backdrop-blur rounded-lg pl-10 pr-4 py-3 text-white placeholder:text-slate-500 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/30 outline-none transition"
                  placeholder="••••••••"
                />
              </div>
            </div>

            {error && (
              <div
                className="text-rose-400 text-sm bg-rose-500/10 border border-rose-500/20 rounded-lg px-4 py-2.5"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              data-testid="login-submit-button"
              className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 disabled:cursor-not-allowed text-white font-semibold py-3 rounded-lg flex items-center justify-center gap-2 transition-all shadow-[0_0_20px_rgba(37,99,235,0.4)] hover:shadow-[0_0_30px_rgba(37,99,235,0.6)] hover:-translate-y-0.5 active:translate-y-0"
            >
              {loading ? "Entrando..." : "Entrar"}
              {!loading && <ArrowRightIcon size={16} weight="bold" />}
            </button>

            <div className="text-center text-xs text-slate-500 pt-2 border-t border-white/5">
              Conta demo: <span className="text-blue-400 font-mono">admin@assistencia.com</span> / <span className="text-blue-400 font-mono">admin123</span>
            </div>
          </form>
        </div>

        <p className="text-center text-xs text-slate-500 mt-6">
          © {new Date().getFullYear()} Assistência Manager. Sistema profissional de gestão.
        </p>
      </motion.div>
    </div>
  );
}
